module.exports = __webpack_public_path__ + "images/emoji/red_circle.493b6f504430d6c54ba9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/red_circle.png
// module id = mlqD
// module chunks = 14